import axiosAuth from '@/services/axios_auth'
import type {CompetitorsResponse, SuggestionsRequestBody, ApiSuggestionsResponse, DetailsRequestBody, DetailsResponse} from '~/types/ccrs.d'

export const useCcrsService = () => {
  const runtimeConfig = useRuntimeConfig()
  const baseURL = runtimeConfig.public.BASIC_API_URL || 'https://api-stg.dev.fst.com'

  const ccrsAxios = axiosAuth.create({
    baseURL: runtimeConfig.public.CCRS_API || (baseURL + '/ccrs-api/1.0.0')
  })

  async function getCompetitors(): Promise<CompetitorsResponse | null> {
    const res = await ccrsAxios.get('/competitors').catch(() => null)
    return res ? (res.data as CompetitorsResponse) : null
  }

  async function postSuggestions(requestBody: SuggestionsRequestBody, signal?: AbortSignal): Promise<ApiSuggestionsResponse | null> {
    const res = await ccrsAxios.post('/suggestions', requestBody, {signal}).catch(() => null)
    return res ? (res.data as ApiSuggestionsResponse) : null
  }

  async function postDetails(requestBody: DetailsRequestBody): Promise<DetailsResponse | null> {
    const res = await ccrsAxios.post('/details', requestBody).catch(() => null)
    return res ? (res.data as DetailsResponse) : null
  }

  return {getCompetitors, postSuggestions, postDetails}
}

export type UseCcrsService = ReturnType<typeof useCcrsService>

export default useCcrsService
